__webpack_require__.p = "/mailbox-sidebar-ui-changes/onboarding/";